import { render, staticRenderFns } from "./photogallery.vue?vue&type=template&id=7b7da446&scoped=true&"
import script from "./photogallery.vue?vue&type=script&lang=js&"
export * from "./photogallery.vue?vue&type=script&lang=js&"
import style0 from "./photogallery.vue?vue&type=style&index=0&id=7b7da446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7da446",
  null
  
)

export default component.exports